<script setup>
defineProps({
  rating: Number,
  reviewRating: Boolean,
});
const stars = [1, 2, 3, 4, 5];
// Процент заливки конкретной звезды: для 4.87 → 1..4 = 100%, 5-я = 87%
const fill = (item, rating) => {
  const r = Number(rating);
  if (isNaN(r)) return 0;
  return Math.max(0, Math.min(1, r - (item - 1))) * 100;
};
</script>

<template>
  <div class="flex items-center justify-center">
    <span v-for="item in stars" :key="item" class="relative inline-block w-4 h-4">
      <!-- база: пустая звезда -->
      <svg class="w-4 h-4 text-gray-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
        fill="currentColor" viewBox="0 0 22 20">
        <use href="#ic-star" />
      </svg>
      <!-- заливка по проценту -->
      <span class="absolute top-0 left-0 h-4 overflow-hidden" :style="{ width: fill(item, rating) + '%' }">
        <svg class="w-4 h-4 max-w-none text-yellow-300" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
          fill="currentColor" viewBox="0 0 22 20">
          <use href="#ic-star" />
        </svg>
      </span>
    </span>

    <span v-if="reviewRating" itemprop="reviewRating" class="flex items-center justify-center" itemscope itemtype="https://schema.org/Rating">
      <meta itemprop="worstRating" content="1">
      <span v-if="!isNaN(rating)" itemprop="ratingValue" class="ml-1 text-sm font-bold text-gray-900 dark:text-gray-400">{{rating}}</span>
      <span v-else itemprop="ratingValue" class="ml-1 text-sm font-bold text-gray-900 dark:text-gray-400">0</span>
      <span itemprop="bestRating" content="5"></span>
    </span>
  </div>
</template>
